/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: BooleanShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/15 @ 159
 * ---
 * Description:
 */

import { ShapeControl, ShapeControlInitParams } from './ControlGroup';
import { ControlTypes }                         from '../../selection-properties';
import { SelectSCItem } from './SelectShapeControl';

export class BooleanShapeControl extends ShapeControl<boolean> {
  constructor(initParams: ShapeControlInitParams<boolean>) {
    super(initParams);
    this.controlType = ControlTypes.CHECKBOX;
  }
}